import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import { FilterProvider } from './contexts/FilterContext';
import { DefinitionsProvider } from './contexts/DefinitionsContext';
import { AppShell } from './components/layout/AppShell';
import { DefinitionsDrawer } from './components/definitions/DefinitionsDrawer';
import { Dashboard } from './pages/Dashboard';
import { TerritoryDetail } from './pages/TerritoryDetail';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mmvkesgikcah">
      <FilterProvider data-id="element-1" data-mp="2mndna7xolord">
        <DefinitionsProvider data-id="element-2" data-mp="2mjzo18kbdvo5">
          <AppShell data-id="element-3" data-mp="31b8lu4ydencd">
            <Routes data-id="element-4" data-mp="31brz38d2snk2">
              <Route path="/" element={<Dashboard data-id="element-6" data-mp="31cjpm4rtfv3h" />} data-id="element-5" data-mp="31c1gw8nyvoeo" />
              <Route path="/territory" element={<TerritoryDetail data-id="element-8" data-mp="2wiffxdr618yp" />} data-id="element-7" data-mp="2wjgu3r3habkn" />
              <Route path="/territory/:territoryId" element={<TerritoryDetail data-id="element-10" data-mp="28te4dhn1dhp7" />} data-id="element-9" data-mp="28ufp6dtutik4" />
              <Route path="/territory/:territoryId/aop/:aopId" element={<TerritoryDetail data-id="element-12" data-mp="23u9uspw79hyc" />} data-id="element-11" data-mp="28sbar1ybx15l" />
              <Route path="*" element={<Navigate to="/" replace data-id="element-14" data-mp="3ijxoypkvdyjd" />} data-id="element-13" data-mp="23t8i6gzjcnei" />
            </Routes>
          </AppShell>
          <DefinitionsDrawer data-id="element-15" data-mp="3ii4s22026sok" />
          <Toaster position="bottom-right" data-id="element-16" data-mp="3ml12v6jcxkhy" />
        </DefinitionsProvider>
      </FilterProvider>
    </BrowserRouter>;
}